import { render, staticRenderFns } from "./Cross.vue?vue&type=template&id=b84be92e&scoped=true"
import script from "./Cross.vue?vue&type=script&lang=js"
export * from "./Cross.vue?vue&type=script&lang=js"
import style0 from "./Cross.vue?vue&type=style&index=0&id=b84be92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84be92e",
  null
  
)

export default component.exports